import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { releasesAPI } from '../services/api';
import '../styles/landing.css';

function ReleasesList() {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReleases();
  }, []);

  const loadReleases = async () => {
    try {
      const response = await releasesAPI.getAll();
      const data = response?.data || [];
      // Backend already sorts by order, so we just reverse to show newest first
      const releasesArray = Array.isArray(data) ? data : [];
      setReleases([...releasesArray].reverse());
    } catch (error) {
      console.error('Error loading releases:', error);
      setReleases([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh' }}>
          <h1 className="section-title" style={{ marginBottom: '40px' }}>ALL RELEASES</h1>
          <p style={{ color: '#a0a0a0', textAlign: 'center' }}>Loading releases...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="container" style={{ paddingTop: '100px', paddingBottom: '80px' }}>
        <h1 className="section-title" style={{ marginBottom: '40px' }}>ALL RELEASES</h1>
        <div className="releases-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '30px' }}>
          {!Array.isArray(releases) || releases.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#a0a0a0' }}>
              <p>No releases available yet.</p>
              <Link to="/" style={{ color: '#228b22', textDecoration: 'none', marginTop: '20px', display: 'inline-block' }}>
                ← Back to Home
              </Link>
            </div>
          ) : (
            releases.map((release) => (
              <Link 
                key={release.id} 
                to={`/releases/${release.id}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block', height: '100%' }}
              >
                <div className="release-card" style={{ cursor: 'pointer' }}>
                  <div 
                    className="release-image-placeholder"
                    style={release.image ? {
                      backgroundImage: `url(${release.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    } : {}}
                  ></div>
                  <h3 className="release-artist">{release.artist}</h3>
                  <p className="release-title">{release.title}</p>
                  <p className="release-description">{release.description}</p>
                  <span className="read-more">view details →</span>
                </div>
              </Link>
            ))
          )}
        </div>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ReleasesList;

